import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

export { StyledContainer };
